// extracted by mini-css-extract-plugin
export default {"list":"CartList_list__oaPFq","title":"CartList_title__pTYWO"};